import dimensionSelector from './dimensionSelector/index'
import conditionItem from './conditionItem/index'
import eventSelector from './eventSelector/index'
import datePicker from './datePicker/index'
import webPlayer from './webPlayer/index'
import {util} from '../utils'
let components = [
  dimensionSelector,
  conditionItem,
  eventSelector,
  datePicker,
  webPlayer
]

components.forEach(component => {
  component.install = function (Vue) {
    Vue.component(util.toCamel('biz_' + component.name), component)
  }
})

export default {
  dimensionSelector,
  conditionItem,
  eventSelector,
  datePicker,
  webPlayer
}
